import { FuncionarioModel } from './funcionario.model';

export class VisitaModel {

  constructor(

    public fechaInicioAgendada: string,
    public horaInicioVisita: string,
    public horaFinVisita: string,
    public dependencia: any,
    public aQuienVisita: FuncionarioModel,
    public todoElDia?: boolean,
    public nombreVisitante?: string,
    public tipoDocumentoVisitante?: string,
    public numeroDocumentoVisitante?: string,
    public sede?: string,
    public numeroDocumentoUsuarioAnterior?: string,
    public tipoDocumentoUsuarioAnterior?: string,
    public fechaFinAgendada?: string,
    public idDependecia?: string,
    public nuevaAgenda?: boolean,
    public primerNombre?: string,
    public segundoNombre?: string,
    public primerApellido?: string,
    public segundoApellido?: string,
    public tipoVisita?: string
	
  ) {

  }


}
